export default __webpack_public_path__ + "static/media/photo--lg--misc-16.192d935b.jpg";